

























import Vue from 'vue'
import { ProjectDetailText } from '@/types/service-response'
import { UiLanguageItem, UiLanguageList } from '@/types'

interface LanguageListItem {
  id: number
  code: string
  text: string
}

interface ComponentData {
  languageList: LanguageListItem[]
}

export default Vue.extend({
  name: 'TextLanguagesDialog',

  components: {},

  props: {
    show: {
      type: Boolean,
      default: false
    },
    isEdit: Boolean,
    projectDetailText: Array as () => ProjectDetailText[]
  },

  data (): ComponentData {
    return {
      languageList: []
    }
  },

  watch: {},
  computed: {
    uiLanguageList (): UiLanguageList {
      return this.$store.state.uiLanguageList
    },
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.$emit('close')
    },

    onFormSubmit (): void {
      let payload: ProjectDetailText[] = this.projectDetailText.map((item: ProjectDetailText) => {
        let foundItem: LanguageListItem | undefined = this.languageList.find((i: LanguageListItem) => i.id === item.Sprache)
        if(foundItem) {
          item.Text = foundItem.text
        }

        return item
      })

      this.$emit('save', payload)
    }
  },

  mounted () {
    this.languageList = this.uiLanguageList.map((item: UiLanguageItem) => {
      return {id: item.syzId ,code: item.code, text: ''}
    })
    this.projectDetailText.forEach((item: ProjectDetailText) => {
      let foundItem: LanguageListItem | undefined = this.languageList.find((i: LanguageListItem) => i.id === item.Sprache)
      if(foundItem) {
        foundItem.text = item.Text ? item.Text : ''
      }
    })
  }
})
